import { render, staticRenderFns } from "./SavedViewsMenu.vue?vue&type=template&id=f9a3f26a&scoped=true"
import script from "./SavedViewsMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavedViewsMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SavedViewsMenu.vue?vue&type=style&index=0&id=f9a3f26a&prod&scoped=true&lang=css"
import style1 from "./SavedViewsMenu.vue?vue&type=style&index=1&id=f9a3f26a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a3f26a",
  null
  
)

export default component.exports